import { useState } from "react";

import { useLogin } from "../hooks/useSession";

export function LoginPage() {
  const login = useLogin();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  return (
    <div className="login">
      <form
        className="login__card"
        onSubmit={(event) => {
          event.preventDefault();
          login.mutate({ email, password });
        }}
      >
        <p className="login__brand">
          {/* Znak Folwark Labs — patrz `design/brand/pig-current.svg`.
              Osobna kopia z własnym `id` maski, bo ekran logowania renderuje
              się poza `Shell`. */}
          <svg viewBox="38 15 151 153" aria-hidden="true">
            <mask id="znak-login" maskUnits="userSpaceOnUse" x="0" y="0" width="200" height="200">
              <rect width="200" height="200" fill="#fff" />
              <ellipse cx="100" cy="130" rx="30" ry="22" fill="#000" />
              <ellipse cx="91" cy="130" rx="4.6" ry="7" fill="#fff" />
              <ellipse cx="109" cy="130" rx="4.6" ry="7" fill="#fff" />
              <path d="M62 96 L44 90" fill="none" stroke="#000" strokeWidth="4" strokeLinecap="round" />
              <path d="M138 96 L156 90" fill="none" stroke="#000" strokeWidth="4" strokeLinecap="round" />
              <circle cx="77" cy="99" r="15" fill="none" stroke="#000" strokeWidth="4" />
              <circle cx="123" cy="99" r="15" fill="none" stroke="#000" strokeWidth="4" />
              <circle cx="77" cy="99" r="6" fill="#000" />
              <circle cx="123" cy="99" r="6" fill="#000" />
              <path d="M92 99 Q100 94 108 99" fill="none" stroke="#000" strokeWidth="4" strokeLinecap="round" />
            </mask>
            <g mask="url(#znak-login)" fill="currentColor">
              <path d="M52 82 L48 40 Q47 32 55 36 L90 58 Z" />
              <path d="M148 82 L152 40 Q153 32 145 36 L110 58 Z" />
              <path d="M40 104 C40 71 67 52 100 52 C133 52 160 71 160 104 C160 141 133 166 100 166 C67 166 40 141 40 104 Z" />
              <circle cx="161" cy="48" r="6" />
              <circle cx="175" cy="32" r="4" />
              <circle cx="184" cy="20" r="2.6" />
            </g>
          </svg>
          Folwark Labs
        </p>

        <h1>Portfolio&nbsp;HQ</h1>
        <p className="lead">Księga całego portfolio. Dostęp tylko dla zespołu.</p>

        <div className="field">
          <label htmlFor="email">Adres e-mail</label>
          <input
            id="email"
            type="email"
            autoComplete="username"
            required
            value={email}
            onChange={(event) => setEmail(event.target.value)}
          />
        </div>

        <div className="field">
          <label htmlFor="password">Hasło</label>
          <input
            id="password"
            type="password"
            autoComplete="current-password"
            required
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
        </div>

        {login.isError && (
          <p className="form-error" role="alert">
            {login.error instanceof Error ? login.error.message : "Logowanie nie powiodło się"}
          </p>
        )}

        <button className="btn btn--primary" type="submit" disabled={login.isPending}>
          {login.isPending ? "Loguję…" : "Zaloguj się"}
        </button>
      </form>
    </div>
  );
}
